import { makeStyles } from '@material-ui/core/styles';

const role = {
  border: '1px solid #2C2D3E4D',
};

export const useStyles = makeStyles(() => ({
  scrollBox: {
    width: '100%',
    height: '360px',
    overflowY: 'auto',    
    overflowX: 'hidden',

  },
  listItem: {
    border: role.border,
    borderRadius: '10px',
    marginBottom: '20px',
    padding: '0',
  },
  emptyMessage: {
    fontFamily: 'Roboto',
    fontStyle: 'normal',
    fontWeight: 400,
    fontSize: '1em',
    color: '#2C2D3E',
    marginTop: '12px',
    paddingLeft: '20px;',
  },
  iconCircle: {
    display: 'inline-block',
    width: '28px',
    height: '28px',
    marginLeft: '10px',
    verticalAlign: 'middle',
    borderRadius: '50%',
    '&:hover': {
      backgroundColor: '#CACAFC5E',
    },
  },
  defaultRoleIcon: {
    margin: '5px',
  },
  roleName: {
    fontWeight: 700,
    borderBottom: role.border,
    padding: '10px',
    display: 'flex',
    justifyContent: 'space-between',
  },
  roleDescription: {
    borderBottom: role.border,
    padding: '10px',
    display: 'flex',
    fontSize: '1em',
  },
  roleDescriptionTitle: {
    marginRight: '10px',
    fontWeight: 550,
  },
  rolePermissions: {
    padding: '10px',
    fontWeight: 550,
  },
}));
